import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  validatePass,
  validationResult,
} from '@/redux/reducers/help-request-reducer';
import country from '@/data/phoneCountry';
import { cn } from '@/utils/cn';
import TextBase from '../Typography/TextBase';
import TextSpan from '../Typography/TextSpan';
import ImageComponentV2 from '../Image/ImageComponentV2';

function PhoneNumberInput({
  isDisable = false,
  value = '',
  onChangeHandler,
  placeholder = '',
  label = 'Phone',
  isRequired = false,
  className = '',
  name = 'phone',
  validate = false,
}) {
  const dispatch = useDispatch();
  const [phone, setPhone] = useState(value);
  const [isInvalidPhone, setIsInvalidPhone] = useState(true);
  const [isOpenCountrySelect, setIsOpenCountrySelect] = useState(false);
  const [onSelectedCountry, setOnSelectedCountry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [error, setError] = useState('');
  // const [error, setError] = useState("Invalid phone number! Please Try Again.");

  useEffect(() => {
    setPhone(value);
    // if (value) {
    // }
  }, [value]);

  const handleCountrySelect = () => {
    setIsOpenCountrySelect((prevState) => {
      const newState = !prevState;
      return newState;
    });
  };

  const handleClose = (data) => {
    setIsOpenCountrySelect(data);
  };

  const handleSelectedCountry = (data) => {
    setOnSelectedCountry(data);
  };

  const handlePhoneChange = (e) => {
    const updatedValue = String(e.target.value.trim()).replace(
      /([^+0-9]+)/gi,
      '',
    );
    setPhone(updatedValue);

    onChangeHandler({ target: { value: updatedValue, name: e.target.name } });
  };

  useEffect(() => {
    if (onSelectedCountry !== null) {
      const countryData = country.find((c) => c.id === onSelectedCountry);
      setSelectedCountry(countryData);
    }
  }, [onSelectedCountry]);

  useEffect(() => {
    if (validate) {
      if (phone?.length >= 10) {
        setIsInvalidPhone(false);
        setError('');
        dispatch(validatePass({ name }));
      } else {
        setIsInvalidPhone(true);
        setError('the number is incorrect');
        dispatch(validationResult({ invalid: true, name }));
      }
    }
  }, [validate]);

  useEffect(() => {
    if (phone?.length >= 10) {
      setIsInvalidPhone(false);
    } else {
      setIsInvalidPhone(true);
    }
  }, [phone]);

  return (
    <div className={cn('phone-number-input relative w-full', className)}>
      <div
        className={cn(
          'flex flex-row items-center h-14 justify-center pl-12 border border-senate rounded-[4px] overflow-hidden font-encode-sans focus-within:border-2 active:border-2',
          {
            '!border-infrared-burn': error,
          },
        )}
      >
        <div
          className="flex items-center"
          tabIndex={0}
          role="button"
          onClick={handleCountrySelect}
        >
          <ImageComponentV2
            src={selectedCountry ? selectedCountry?.flag : '/icons/bd.png'}
            width={26.6}
            height={16}
            className="flex-shrink-0 rounded-[4px]"
            alt="Country Flag"
            loading="lazy"
          />
          <TextBase
            text={selectedCountry ? selectedCountry.countryCode : '+880'}
            className="text-base lg:text-base font-semibold text-senate ml-12 mr-8"
          />
          {/* TODO: UNCOMMENT WHEN MULTIPLE COUNTRY CODE WILL BE IMPLEMENTED */}
          {/* <div className="min-w-[18px]">
            <Icon type="angle-down" width="16" height="16" color="#292524" />
          </div> */}
        </div>
        <TextSpan
          text="|"
          className="text-base lg:text-base text-himalayan-poppy inline-block ml-[30px] mr-4"
        />
        <input
          type="tel"
          name={name}
          className="text-gray-dark block w-full px-0 py-16 text-base focus:outline-none focus:ring-0 text-coarse-wool placeholder:text-senate font-encode-sans placeholder:text-base placeholder:font-encode-sans placeholder:font-normal font-medium"
          maxLength={10}
          placeholder={placeholder}
          onChange={handlePhoneChange}
          value={phone}
          disabled={isDisable}
        />
      </div>
      <label
        className={cn(
          'absolute top-[17px] font-encode-sans left-3 text-sm font-medium text-senate leading-16 tracking-[0.24px] bg-white transform -translate-y-6 px-[6px]',
          {
            '!text-infrared-burn': error,
          },
        )}
      >
        {label}
        {isRequired ? (
          <TextSpan
            text="*"
            className="text-sm lg:text-sm text-infrared-burn"
          />
        ) : null}
      </label>

      {error ? (
        <TextSpan
          text={error}
          className="text-sm lg:text-sm text-infrared-burn font-medium leading-4 tracking-[0.24px] px-16"
        />
      ) : null}
    </div>
  );
}

export default PhoneNumberInput;
